import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthStatusService } from '@fpr/core/services/auth-status.service';
import { ConfigService } from '@fpr/core/services/config.service';
import { LocaleService } from '@fpr/core/services/locale.service';
import { WINDOW } from '@fpr/core/services/window.factory';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationGuard  {
    private readonly authStatusService = inject(AuthStatusService);
    private readonly configService = inject(ConfigService);
    private readonly localeService = inject(LocaleService);
    private readonly window = inject<Window>(WINDOW);


    canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        return this.authStatusService.getStatus()
            .pipe(
                mergeMap(({ isLoggedIn, swid }) => {

                    if (!isLoggedIn || !swid) {

                        const referer = this.localeService.getPathWithLocale(`${this.configService.APP_CONTEXT_PATH}${state.url}`);

                        this.window.location.href =
                            this.localeService.getPathWithLocale(`${this.configService.LOGIN_URI}/?returnUrl=${referer}`);

                        return of(false);

                    }

                    return of(true);

                })
            );

    }

}
